// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import vSelect from 'vue-select'
import VueInsProgressBar from 'vue-ins-progress-bar'
import IdleVue from 'idle-vue'
import VueApexCharts from 'vue-apexcharts'
import VueAnime from 'vue-animejs';
import { StreamBarcodeReader } from 'vue-barcode-reader'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

const l7app = new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})

// v-select
Vue.component('v-select', vSelect)
Vue.config.productionTip = false
// apexcharts
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
// progressbar
Vue.use(VueInsProgressBar, {position: 'relative', show: true, height: '3px'})
Vue.use(IdleVue, {eventEmitter: l7app, idleTime: 60000 * 30})
// BootstrapVue
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
// StreamBarcodeReader
Vue.use(StreamBarcodeReader)
// Anime.js
Vue.use(VueAnime)

// limit filter
Vue.filter('limit', (array, limit) => {
  if (limit !== 0) {
    if (array.length > limit) {
      array = array.slice(0, limit)
    }
  }
  return array
})
// date filter
Vue.filter('date', (value, options) => {
  if (!value) return ''
  let jsDate = new Date(value * 1000)
  return jsDate.toLocaleDateString('en-US', options)
})
// dateSelect  filter
Vue.filter('dateSelect', (value, options) => {
  if (!value) return ''
  let jsDate = new Date(value)
  return jsDate.toLocaleDateString('en-US', options)
})
// inputDate filter
Vue.filter('inputDate', (value) => {
  if (!value) return ''
  let jsDate = new Date(value)
  return (jsDate.getFullYear() + '-' + (jsDate.getMonth() + 1) + '-' + jsDate.getDate()).replace(/(^|\D)(\d)(?!\d)/g, '$10$2')
})
// currency filter
Vue.filter('currency', (value) => {
  if (typeof value !== 'number') {
    value = Number(value)
  }
  return '$' + value.toFixed(2)
})
// capitalize filter
Vue.filter('capitalize', (value) => {
  return (value) ? value.charAt(0).toUpperCase() + value.substr(1).toLowerCase() : ''
})
// truncate filter
Vue.filter('truncate', (value, length) => {
  if (value.length > length) {
    let output = value.substring(0,length) + '...'
    return output
  } else {
    return value;
  }
})



// WEBPACK FOOTER //
// ./src/main.js